import { cva } from 'class-variance-authority'

export const backgroundStyles = cva(
  `
    flex
    items-center
    justify-center
    bg-transparent
    mr-2
  `,
  {
    variants: {
      variant: {
        checkbox: 'm-0 p-0',
      },
      backgroundColor: {
        transparent: 'bg-transparent',
        level0: 'bg-neutral-0',
        level1: 'bg-neutral-25',
        level2: 'bg-neutral-50',
        priority1: 'bg-orange-0',
        priority2: 'bg-orange-25',
        emphasis: 'bg-moss-0',
        loud: 'bg-moss-300',
        black: 'bg-neutral-900',
        red: 'bg-red-900',
      },
      backgroundStyle: {
        circle: 'rounded-full',
        rounded: 'rounded-lg',
      },
      size: {
        none: '',
        // Font Awesome t-shirt size scale
        '2xs': 'w-6 h-6',
        xs: 'w-7 h-7',
        sm: 'w-8 h-8',
        lg: 'w-10 h-10',
        xl: 'w-12 h-12',
        '2xl': 'w-14 h-14',

        // Font Awesome literal size scale
        '1x': 'w-8 h-8',
        '2x': 'w-14 h-14',
        '3x': 'w-20 h-20',
        '4x': 'w-26 h-26',
        '5x': 'w-32 h-32',
        '6x': 'w-40 h-40',
        '7x': 'w-46 h-46',
        '8x': 'w-52 h-52',
        '9x': 'w-58 h-58',
        '10x': 'w-64 h-64',
      },
    },
    defaultVariants: {
      backgroundColor: 'transparent',
      backgroundStyle: 'circle',
      size: 'none',
    },
  }
)
